
import axios from 'axios'

export const getProgramsCheckup = async (patientInfo) => {
  const url = 'https://lk.k31.ru/api/v7/checkup/section/'
  const token = 'RfiluWyt6Tvgq3QJMC2BSPDpWyL9zAlp_1734004703'
  const params = {
    gender_id: patientInfo.genderId,
    age: patientInfo.age,
    user_id: 0,
    filial_id: patientInfo.filialId
  }

  const response = await axios.get(url, {
    params,
    headers: {
      Authorization: `Bearer ${token}`
    }
  })

  if (response.data.status !== 'ok') {
    throw new Error(
      response.data.message ?? 'Произошла ошибка, попробуйте позже'
    )
  }

  return response.data.data
}
